import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'components/LazyLoad/LazyLoad';
import styles from './ManageBriefsBannerAd.module.scss';
import config from '../../../config';

const getImage = (image = '') => {
  return `${config.partnerImages}/${image}`;
};

const ManageBriefsBannerAd = ({ advert = null }) => {
  return advert ? (
    <>
      <div className={styles.container}>
        <a href={advert.link_destination} target="_blank" rel="noreferrer">
          <LazyLoad>
            <img
              className={`${styles.image} ${styles.desktopImage}`}
              src={getImage(advert.desktop_image)}
              alt={advert.partner_name}
            />
          </LazyLoad>
          <LazyLoad>
            <img
              className={`${styles.image} ${styles.mobileImage}`}
              src={getImage(advert.mobile_image)}
              alt={advert.partner_name}
            />
          </LazyLoad>
        </a>
      </div>
    </>
  ) : (
    <noscript />
  );
};

ManageBriefsBannerAd.propTypes = {
  advert: PropTypes.object,
};

export default ManageBriefsBannerAd;
